module.exports = __webpack_public_path__ + "static/img/up-t.c39a92ad.png";